module.exports = __webpack_public_path__ + "img/icon4.de764823.png";